import { createAsyncThunk } from '@reduxjs/toolkit'
import ProcessedMediaCustomizations from './processed-media-customizations-model'
import {
  delete_processedMediaCustomizations,
  load_processedMediaCustomizationss,
  store_processedMediaCustomizations,
} from './processedMediaCustomizations-service'

export const LoadProcessedMediaCustomizationssAsync = createAsyncThunk<
  any,
  any
>(
  'composer/load/processedMediaCustomizations',
  async (params: { uid: string }) => {
    return await load_processedMediaCustomizationss(params)
  },
)

export const CreateProcessedMediaCustomizationsAsync = createAsyncThunk<
  any,
  any
>(
  'composer/create/processedMediaCustomizations',
  async (params: ProcessedMediaCustomizations) => {
    return await store_processedMediaCustomizations(params)
  },
)

export const DeleteProcessedMediaCustomizationsAsync = createAsyncThunk<
  any,
  any
>('composer/delete/processedMediaCustomizations', async (params) => {
  return await delete_processedMediaCustomizations(params)
})
